import { TFunction } from 'i18next';
import { mixed, object, string } from 'yup';

export const createEstateContactFormSchema = (
  t: TFunction,
  phoneRequired: boolean,
  addressRequired: boolean,
  isUserEstate: boolean
) => {
  const requiredField = (key: string) => t('contactForm.errorMessage', { field: t(`contactForm.${key}`) });

  const validationSchema = {
    subject: string().strict(),
    message: string().strict(),
    firstName: string().strict().required(requiredField('firstName')),
    lastName: string().strict().required(requiredField('lastName')),
    email: string().email().strict().required(requiredField('email')),
    phone: string().strict(),
    street: string().strict(),
    streetNumber: string().strict(),
    zip: string().strict(),
    city: string().strict(),
    accept: mixed()
      .transform((value) => {
        if (value === 'true') {
          return true;
        }
        return value;
      })
      .oneOf([true], t('contactForm.accept')),
  };

  if (phoneRequired) {
    validationSchema.phone = validationSchema.phone.required();
  }

  if (addressRequired) {
    validationSchema.street = validationSchema.street.required(requiredField('street'));
    validationSchema.streetNumber = validationSchema.streetNumber.required(requiredField('streetNumber'));
    validationSchema.zip = validationSchema.zip.required(requiredField('zip'));
    validationSchema.city = validationSchema.city.required(requiredField('city'));
  }

  if (isUserEstate) {
    validationSchema.accept = validationSchema.accept.oneOf([false]);
  }

  return object().shape(validationSchema);
};
